// extracted by mini-css-extract-plugin
module.exports = {"submit":"LoginForm_submit__kJy2h form-group row justify-content-center","button":"LoginForm_button__2sqQt"};